<template>
	<div class="FilterStatusTheme">
		<div class="themName">{{themName}}:</div>
		<span class="themlis hovertext" :class="[isSelected ==item.id?selected: '']" @click="seletedF(item)" v-for="item in themeList" :key="item.id">
			{{item.keyword}}
		</span>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selected:{
					selectedClass:true,
					borderColor:true,
					// thmeBackColor:true
				},
				isSelected: '',
				value1:'',
				molist:[
					{
						uuid:'all',
						name:'全部'
					}
				]
			}
		},
		
		props:{
			themName:{
				type:String,
				default:'状态'
			},
            themeList:{
				type:Array,
			}
			
		},
		mounted(){
			//this.isSelected = this.themeList[0].id
		},
		methods: {
			seletedF(item) {
				this.isSelected = item.id
				this.$emit('changeVal',{'type':item,'val':null})
			}
		}
	}
</script>

<style lang="less">
	.FilterStatusTheme {
		font-size: 14px;
		display: flex;
		align-items: center;
        flex-wrap: wrap;
		.themlis {
			    margin: 0px 5px;
			// margin-left: 20px;
			display: inline-block;
			padding: 0px 5px;
			height: 24px;
			line-height: 22px;
			border: 1px solid transparent;
			border-radius: 5px;
            cursor: pointer;

			&.selectedClass {
				 color: #41a0ff;
				border: 1px solid #41a0ff;
				border-radius: 5px;
				// color:#fff;
			}
		}

		.themName {
			color: @huiseColor;
			height: 40px;
			line-height: 40px;
		}
	}
</style>
